export { default } from './Pager';
